import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

interface SocialMediaInformationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
}

export function SocialMediaInformationModal({ open, setOpen }: SocialMediaInformationModalProps) {
	return (
		<ConfirmationModal title="Connecting Social Media Accounts" open={open} setOpen={setOpen} blur>
			<div>
				<div className="mb-8">
					By default, each slider is configured with a 10% bonus for every social media account connected to
					Loyalink profiles. Customize the bonus slider up to 100% for each linked account. The greater the
					bonus, the higher the chances of winning. Combine multiple accounts for an even greater winning
					edge!
				</div>
				<div className="space-y-2">
					<Button variant="secondary" fullWidth onClick={() => setOpen(false)}>
						Close
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export type SocialMediaInformationModalManagedProps = Record<string, unknown>

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'social-media-information': SocialMediaInformationModalManagedProps
	}
}

export function ManagedSocialMediaInformationModal({
	onClose,
}: SocialMediaInformationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<SocialMediaInformationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
		/>
	)
}
